import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  standalone: true,
  styles: `
  iframe {
  width: 100vw;
  height: 100vh;
  border: none;
}

  `
})
export class PdfViewerComponent implements OnInit {
  pdfUrl: SafeResourceUrl | undefined;
  title:string = '';
  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private titleService: Title
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const pdfPath = params['pdfPath'];
      const title = pdfPath.split('/').pop()?.replace('.pdf', '');
      
      if (pdfPath) {
        this.titleService.setTitle(title + ' | eFALAK');
        this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(pdfPath);
      }
    });
  }
}
